import React from "react";
import ReactDOM from "react-dom/client";
// Bootstrap (CSS only, reduced to the classes the app uses) must stay first: it used to be a <link> before main.css,
// so the app's own CSS keeps overriding it. See scripts/build_bootstrap_subset.js.
import "./vendor/bootstrap-subset.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { installAxiosUnauthorizedRedirect } from "./axiosSetup";
import { installPlainNumberInputScrollGuard } from "./utils/plainNumberInputs";

installAxiosUnauthorizedRedirect();
installPlainNumberInputScrollGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
